<template>
    <app-transition>
        <Dialog
            class="VerifyMessage"
            :only-text="true"
            @close="handleClose"
        >
            <v-row text-center>
                <v-col>
                    <div class="VerifyMessage-title font-weight-bold text-h6">
                        <p>{{ $t('dialogs.verify_content.showtime_intro', { username: name }) }}</p>
                        <p class="mt-4">
                            {{ $t('dialogs.verify_content.showtime_favor') }}
                            <router-link :to="{name: nextStepVerificationRouteName}">
                                {{ $t('dialogs.verify_account') }}
                            </router-link> - {{ $t('dialogs.verify_content.showtime_reason') }} 😎
                        </p>
                    </div>
                </v-col>
            </v-row>
        </Dialog>
    </app-transition>
</template>

<script>
import { mapGetters } from "vuex";
import Dialog from "@/components/app/form/Dialog";

export default {
    name: "VerifyContentDialog",
    computed: {
        ...mapGetters([
            'nextStepVerificationRouteName'
        ])
    },
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
    },
    components: {
        Dialog,
    }
}
</script>

<style scoped lang="scss">
@import '@/sass/modules/_variables';

.VerifyMessage {
    &-title {
        line-height: 19px;
        a {
            text-decoration: underline;
        }
    }
}
</style>
